import * as yup from 'yup';

const nameSchema = yup
  .string()
  .trim()
  .required('Name is required')
  .max(255, 'Name must be at most 255 characters');

export const lotValidationSchema = yup.object().shape({
  name: nameSchema,
  description: yup.string().trim(),
});

export const levelValidationSchema = lotValidationSchema;

export const levelStructureValidationSchema = yup.object().shape({
  name: nameSchema,
});

export const newLevelStructureValidationSchema = yup.object().shape({
  name: nameSchema,
  lowest_level_name: nameSchema,
  lowest_level_description: yup.string().trim(),
});

export const roleValidationSchema = yup.object().shape({
  level_structure_id: yup
    .number()
    .typeError('Level structure is required')
    .required('Level structure is required'),
  name: nameSchema,
  description: yup.string().trim(),
});
